module.exports = __webpack_public_path__ + "img/4.d97e2707.png";